"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activityPricingHasUniqueId = void 0;
const activityPricingHasUniqueId = (prices) => {
    const visitedCustomIds = [];
    const duplicateId = prices.find((price) => {
        if (visitedCustomIds.includes(price.customId)) {
            return true;
        }
        visitedCustomIds.push(price.customId);
        return false;
    });
    return !Boolean(duplicateId);
};
exports.activityPricingHasUniqueId = activityPricingHasUniqueId;
//# sourceMappingURL=activityPricingHasUniqueId.js.map